import type { FaireProductEntity } from "../../entity_types/product";

export const p_quqp6p9vf7: FaireProductEntity = {
  token: "p_quqp6p9vf7",
  type: "product",
  name: "90129 - STRIPED KNITTED SCARF",
  brandToken: "b_dlc3tm53ak",
  brandName: "Grade & Gather",
  imageUrl:
    "https://cdn.faire.com/fastly/de8bbf19b4c597432a4440a4de02791d5512d25623a18b7bcc529199709e742a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74ce7e4dfa32e9b9fdf6929b67b0c489e382620602f98fcfc62ac678bc0df259.jpeg",
    "https://cdn.faire.com/fastly/f04edb3b66d15f82b0027260655287313a670da3a2ab004c223fe53b9f62130a.jpeg",
    "https://cdn.faire.com/fastly/c8fa609090c5f74b2aeb1e2cccc1669b464f2fbc2c324ae8a93d812b17680163.jpeg",
    "https://cdn.faire.com/fastly/7c6725d23e9db5633a84a8b8e6a5edbeceb98308982925ed41f04b6f2330a228.jpeg",
    "https://cdn.faire.com/fastly/fb6fb57be68df9492b29645c941b01cb579a1f14eceff9dc30a88ff0bdb4057a.jpeg",
  ],
  priceDollars: 19.75,
  description:
    "STRIPED KNITTED SCARF\n\n6Pcs-1Pack (3Pcs Per Color- Black/Ivory)\n\n50% ACRYLIC 43% POLYESTER 4% SPANDEX 3% WOOL\nIMPORTED",
  tags: [],
  msrpDollars: 39.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:56.224Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
